import ResumeView from './resume_view';

const Resume = ResumeView;
export default Resume;
